import React, { useEffect } from "react"
import useScreenSize from "../../hooks/useScreenSize"
import { replaceAll, get } from "../../helpers/utils"
import Link from "../../components/UI/Link/Link"
import * as styles from "./BreadCrumb-tw-styles"
import PropTypes from "prop-types"
import SocialLinks from "../SocialLinks/SocialLinks"
import SocialShareButtons from "../SocialLinks/SocialShareButtons"
import { gaInternalLink } from "../../constants/gtm.constants"
import { labels } from "../../constants/label.constants"
const BreadCrumb = props => {
  const {
    link,
    socialLinks,
    shareThisEnabled,
    heading,
    variant,
    pressreleaseCollection,
    isBreadcrumb,
    breadcrumbTitle,
    textUnderHeading,
    regionalBreadcrumbsCollection,
    isRegionalBreadcrumb,
    internalTitle,
    firstBreadcrumbPathname,
    iconLink
  } = props
  

  const style = styles[variant] || styles.defaultStyle
  const {
    headingDiv,
    headingOne,
    paraUnderHeading,
    container,
    breadcrumbItems,
    breadcrumbItemsStyle,
    breadcrumbDevider,
    leftSection,
    rightSection,
    SocialLink,
    ContainerFive,
    IconLinkCl,
    FaIcon,
    newsLinksOne,
    newsLinksTwo,
    newsLinksWrpr,
    newsLinksContainer,
    rightWrapper,
  } = style
  const pressRelease = get(pressreleaseCollection, "items", [])
  const regionalBreadcrumbs = get(regionalBreadcrumbsCollection, "items", [])
  const screen = useScreenSize()
  let url = ""
  let urlArray = []
  let origin = ""
  if (typeof window != "undefined") {
    url = window.location.origin
    origin = new URL(window.location.href)
    const modifiedURL = origin.pathname.endsWith("/")
      ? origin.pathname?.slice(0, -1)
      : origin.pathname
    urlArray = modifiedURL.split("/")
  }
  let newBreadCrumb = urlArray.slice(0, -1)
  const changeBreadcrumbTitle = (item, index, urlArray = []) => {
    let title = replaceAll(item?.toUpperCase(), "-", " ")
    if (index === urlArray?.length - 2 && breadcrumbTitle) {
      title = replaceAll(breadcrumbTitle?.toUpperCase(), "-", " ")
    }
    else if (index === 1 && firstBreadcrumbPathname) {
      title = firstBreadcrumbPathname.toUpperCase()
    }
    return title
  }

  useEffect(() => {
    // adding gtm events for social share package
   setTimeout(() => {
      function loadSocialButtons(callback) {
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = '//platform-api.sharethis.com/js/sharethis.js#property=12345mypropertykey12345&product=inline-share-buttons';
          document.getElementsByTagName('head')[0].appendChild(script);
          callback();
          let buttons = document.getElementsByClassName('st-btn');
          
          for (let btn of buttons) {
              btn.setAttribute('tabIndex', '0')
              // btn.setAttribute("role", "button")
          }
      }
      function addProperties() {
          var buttons = document.getElementsByClassName('st-btn');
          
          for (let btn of buttons) {
              btn.setAttribute('tabIndex', '0')
              // btn.setAttribute("role", "button")
          }
      }

      loadSocialButtons(addProperties);
      const children = document.querySelectorAll(".st-btn img")
      const socialBtn= document.querySelectorAll(".st-btn")
      if(children?.length > 0) {
      [...children].forEach(e => {
        e?.setAttribute("class", "event_socialmedia_exit")
      })
      socialBtn[0]?.setAttribute("aria-label", "facebook");
      socialBtn[0]?.setAttribute("role", "button");
      socialBtn[1]?.setAttribute("aria-label", "twitter");
      socialBtn[1]?.setAttribute("role", "button");
      socialBtn[2]?.setAttribute("aria-label", "linkedin");
      socialBtn[2]?.setAttribute("role", "button");
      socialBtn[3]?.setAttribute("aria-label", "print");
      socialBtn[3]?.setAttribute("role", "button");
      children[0]?.setAttribute("data-action-detail", "facebook");
      children[1]?.setAttribute("data-action-detail", "twitter");
      children[2]?.setAttribute("data-action-detail", "linkedin");
      children[3]?.setAttribute("data-action-detail", "print");
     }    
   }, 1000)
  }, [])

  const changeBreadcrumbURL = (item, index, urlArray = []) => {
    let urlLink = item
    if (index == 2) {
      if (item === labels.NEWS_AND_EVENT) {
        urlLink = "#"
      } if(item == "jobs") {
        urlLink = `/${urlArray[index - 1]?.charAt(0)?.toUpperCase()+ urlArray[index - 1].slice(1)}/${item?.charAt(0)?.toUpperCase()+ item.slice(1)}/`
      } else {
        urlLink = `/${urlArray[index - 1]}/${item}/`
      }
    } else if(item === "careers") {
      urlLink = `/${item?.charAt(0)?.toUpperCase() + item.slice(1)}`
    } else if (index == 3) {
      urlLink = `/${urlArray[index - 2]}/${urlArray[index - 1]}/${item}/`
    } else {
      urlLink = `/${item}/`
    }

    return urlLink
  }

  function displayBreadCrumb(item, index) {
    return index === urlArray.length - 2 ? (
      screen ? (
        <li className={breadcrumbItemsStyle} key={index}>
          <Link
            ariaLabel={`${changeBreadcrumbTitle(item, index, urlArray)}`}
            url={changeBreadcrumbURL(item, index, urlArray)}
            className="hover:underline"
            gaEventClass={gaInternalLink}
          >
            {changeBreadcrumbTitle(item, index, urlArray)}
          </Link>{" "}
          <span className={breadcrumbDevider}>/</span>
        </li>
      ) : (
        ""
      )
    ) : (
      <li className={breadcrumbItemsStyle} key={index}>
        <Link
          url={changeBreadcrumbURL(item, index, urlArray)}
          className="hover:underline"
          gaEventClass={gaInternalLink}
        >
          {changeBreadcrumbTitle(item, index, urlArray)}
        </Link>{" "}
        <span className={breadcrumbDevider}>/</span>
      </li>
    )
  }
  return (
    <>
      {
        <div className={container}>
          {isBreadcrumb &&
            (isRegionalBreadcrumb ? (
            <nav aria-label="Breadcrumb">
              <ul className={breadcrumbItems} >
                {regionalBreadcrumbs.map((item, index) => (
                  <li key={index} className={breadcrumbItemsStyle}>
                    {item && <Link {...item} className="hover:underline" />}
                    <span className={breadcrumbDevider}> / </span>
                  </li>
                ))}
              </ul>
            </nav>
            ) : (
              <nav aria-label="Breadcrumb">
                <ul className={breadcrumbItems} >
                  <li className={breadcrumbItemsStyle}>
                    {url && (
                      <Link ariaLabel="Home" url="/" target="_self" className="hover:underline" gaEventClass={gaInternalLink}
                        gaEventLabel={'Home'}>
                        HOME
                      </Link>
                    )}{" "}
                    <span className={breadcrumbDevider}> / </span>
                  </li>
                  {urlArray &&
                    urlArray.length > 0 &&
                    newBreadCrumb.map(
                      (elem, index) =>
                        elem != "" && displayBreadCrumb(elem, index)
                    )}
                </ul>
              </nav>
            ))}
        </div>
      }
      <div className={headingDiv}>
        {
          <div className={leftSection}>
            {isBreadcrumb && heading && (
              <h1 role="heading" aria-current="page" className={headingOne}>{heading}</h1>
            )}
            {textUnderHeading && (
              <p className={paraUnderHeading}>{textUnderHeading}</p>
            )}
          </div>
        }
        <div className={rightSection}>
          <div className={rightWrapper}>
            {(screen?.isDesktop || screen?.isTablet) && (
              <div className={SocialLink} id="social-share">
                {shareThisEnabled ? (
                  <SocialShareButtons title={internalTitle}/>
                ) : (
                  socialLinks && (
                    <SocialLinks {...socialLinks} isBreadcrumb={isBreadcrumb} />
                  )
                )}
              </div>
            )}
            {link && (
              <div className={ContainerFive}>
                <Link {...link} gaEventClass={gaInternalLink} />
              </div>
            )}
            {iconLink && (
              <div className={IconLinkCl}>
                <i className={FaIcon}></i>
                <Link {...iconLink} gaEventClass={gaInternalLink} />
              </div>
            )}
            <div className={newsLinksContainer}>
              {pressreleaseCollection &&
                pressRelease?.map((item, idx) => {
                  return (
                    <div key={idx} className={newsLinksWrpr}>
                      <Link
                        url={item?.url?.url}
                        className={
                          typeof window !== "undefined" &&
                          window.location?.pathname === item.url?.url
                            ? `${newsLinksOne}`
                            : `${newsLinksTwo}`
                        }
                        gaEventClass={gaInternalLink}
                      >
                        {item?.url?.label}
                      </Link>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

BreadCrumb.propTypes = {
  pageHeading: PropTypes.string,
  link: PropTypes.object,
  socialLinks: PropTypes.object,
  heading: PropTypes.string,
  shareThisEnabled: PropTypes.bool,
  variant: PropTypes.string,
  pressreleaseCollection: PropTypes.object,
  isBreadcrumb: PropTypes.bool,
  breadcrumbTitle: PropTypes.string,
  firstBreadcrumbPathname: PropTypes.string,
  textUnderHeading: PropTypes.string,
  regionalBreadcrumbsCollection: PropTypes.object,
  isRegionalBreadcrumb: PropTypes.bool,
  internalTitle: PropTypes.string,
  iconLink: PropTypes.object
}

export default BreadCrumb